import { Auth } from 'aws-amplify'
import { logout } from '../../utils'
import { syncCustomAttributes } from '@src/quince-site-common/src/services/newCustomerService/newCustomerService'

const validHostNames = new Set([
  'quince.com',
  'www.quince.com',
  'checkout.quince.com',
  'onequince.com',
  'www.onequince.com',
  'checkout.onequince.com',
])

const checkoutHostNames = new Set(['checkout.quince.com', 'checkout.onequince.com'])

/**
 *
 * @param {URL} url
 * @returns string | null
 */
function isValidQuinceUrl(url) {
  return (
    validHostNames.has(url.host) ||
    validHostNames.has(url.hostname) ||
    // The below ones are to enable for staging/prod preview.
    url.origin.endsWith('.quince.com') ||
    url.origin.endsWith('.onequince.com')
  )
}

export function isCheckoutUrl(urlString) {
  try {
    const url = new URL(urlString)
    return (
      checkoutHostNames.has(url.host) ||
      checkoutHostNames.has(url.hostname) ||
      url.origin.endsWith('checkout.quince.com') ||
      url.origin.endsWith('checkout.onequince.com')
    )
  } catch {
    return false
  }
}

export function getSanitizedRedirectUrls() {
  try {
    const searchParams = new URLSearchParams(location.search)
    const redirecturi = searchParams.get('redirecturi')
    const redirectUrl = new URL(redirecturi)
    if (isValidQuinceUrl(redirectUrl)) {
      return redirectUrl.toString()
    }
  } catch (e) {
    // this will be invoked at SSR. Don't remove
  }
  return null
}

export const logoutIfCustomerIdIsUnavailable = async () => {
  try {
    const currentUser = await Auth.currentAuthenticatedUser()
    if (!currentUser.attributes['custom:customer_id']) {
      const syncSuccessful = await syncCustomAttributes(currentUser.attributes['email'])
      if (syncSuccessful) {
        const currentUser = await Auth.currentAuthenticatedUser({
          bypassCache: true,
        })
        if (currentUser.attributes['custom:customer_id']) {
          return false
        }
      }
      localStorage.setItem('Side:Toast:Error', 'Login failed. For assistance, please contact us.')
      await Auth.signOut()
      logout(() => {})
      return true
    }
    return false
  } catch (error) {
    console.error('Error while fetching user data ', error)
    return true
  }
}

export const globalSignOut = async () => {
  try {
    await Auth.signOut({ global: true })
    logout(() => {})
  } catch (error) {
    console.error('Error during global sign out:', error)
  }
}

// @i18n-ignore
export const SESSION_EXPIRED_KEY = 'session-expired'
export const LOGIN_STATUS_MESSAGE = {
  [SESSION_EXPIRED_KEY]: `Your session has expired.\nPlease login again to continue.`,
}
